import omit from 'lodash/omit';

import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

import CustomInput from './CustomInput';

const CustomSliderField = props => {
  return (
    <CustomInput {...omit(props, 'children')}>
      <Box sx={props?.label ? { mt: 1.0 } : {}}>
        <Slider
          className={`CustomTextField ${props.rounded && 'custom-text-field-rounded'}`}
          style={{
            ...(props.style || props?.label ?  {marginTop: '0.5em'} : {}),
          }}
          color={props.color || 'primary'}
          size={props?.size || 'medium'}
          fullWidth={props?.fullWidth || false}
          sx={{
            ...(props.sx || {}),
          }}
          valueLabelDisplay='auto'
          aria-labelledby='non-linear-slider'
          {...omit(props, 'helperText', 'label', 'style', 'sx', 'className')}
          {...(props.formHookProps || {})}
        />
      </Box>
    </CustomInput>
  );
};

export default CustomSliderField;